import React, { useEffect, useState } from 'react'
import Beneficiary from './Beneficiary'
import Payer from './Payer'

import {
  useCampaignSetup,
  useCampaignSetupDispatch,
} from 'components/Recommendations/Campaign/Context/CampaignSetupContext'
import { fetchDsaRecommendations } from 'api/integrations'

export default function DsaFields() {
  const { setup } = useCampaignSetup()
  const { updateDsaFields } = useCampaignSetupDispatch()
  const [recommendations, setRecommendations] = useState(null)

  useEffect(() => {
    const loadDsaDefaults = async () => {
      const adAccountId =
        setup?.integration_details?.find((x) => x.asset_class === 'ad_account')?.asset_id || null
      if (!adAccountId) return

      const response = await fetchDsaRecommendations(adAccountId)
      if (!response?.success) return

      const partnerDetails = JSON.parse(localStorage.getItem('partnerDetails') || '{}')
      const clientName = partnerDetails?.name || ''

      const beneficiary =
        response?.data?.dsa_recommendations?.[0] || response?.data?.default_dsa_beneficiary || clientName
      const payer =
        response?.data?.dsa_recommendations?.[0] || response?.data?.default_dsa_payor || clientName

      setRecommendations({
        beneficiary,
        payer,
      })

      // if setup doesn't have dsa_beneficiary or dsa_payor, update them with the recommendations
      if (setup?.dsa_beneficiary === null || setup?.dsa_payor === null) {
        updateDsaFields({
          ...( !setup?.dsa_beneficiary && beneficiary ? { dsa_beneficiary: beneficiary } : {} ),
          ...( !setup?.dsa_payor && payer ? { dsa_payor: payer } : {} ),
        })
      }
    }

    loadDsaDefaults()
  }, [])

  return (
    <>
      <Beneficiary recommendation={recommendations?.beneficiary} />

      <Payer recommendation={recommendations?.payer} />
    </>
  )
}